__turbopack_context__.v({
  "brandWord": "TasksHero-module-scss-module__KbVV4G__brandWord",
  "content": "TasksHero-module-scss-module__KbVV4G__content",
  "dots": "TasksHero-module-scss-module__KbVV4G__dots",
  "glow": "TasksHero-module-scss-module__KbVV4G__glow",
  "headline": "TasksHero-module-scss-module__KbVV4G__headline",
  "label": "TasksHero-module-scss-module__KbVV4G__label",
  "line": "TasksHero-module-scss-module__KbVV4G__line",
  "lineBrands": "TasksHero-module-scss-module__KbVV4G__lineBrands",
  "logo": "TasksHero-module-scss-module__KbVV4G__logo",
  "logoArena": "TasksHero-module-scss-module__KbVV4G__logoArena",
  "logoArenaIcon": "TasksHero-module-scss-module__KbVV4G__logoArenaIcon",
  "logoDrift": "TasksHero-module-scss-module__KbVV4G__logoDrift",
  "logoDriftIcon": "TasksHero-module-scss-module__KbVV4G__logoDriftIcon",
  "logoJggl": "TasksHero-module-scss-module__KbVV4G__logoJggl",
  "logoJgglIcon": "TasksHero-module-scss-module__KbVV4G__logoJgglIcon",
  "logoStack": "TasksHero-module-scss-module__KbVV4G__logoStack",
  "root": "TasksHero-module-scss-module__KbVV4G__root",
});
